webpackJsonp([46],{

/***/ "Fgb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-supplement-no-title-layout"},[_c('div',{staticClass:"layout-content user-content form"},[(_vm.isSuccess)?_c('form',{staticClass:"user-bind"},[_c('div',{staticClass:"form-list phone-validate"},[_c('label',[_vm._v("手机号:")]),_vm._v(" "),_c('el-input',{attrs:{"type":"text","placeholder":"中国大陆11位手机号","maxlength":11},on:{"blur":_vm.blurPhoneNumber,"focus":function($event){_vm.focusInput('phoneVerify')}},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}}),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"text"}}),_vm._v(" "),_c('div',{staticClass:"validate",class:_vm.phoneVerify},[_c('i')])],1),_vm._v(" "),_c('div',{staticClass:"form-list captchas-validate"},[_c('label',[_vm._v("图片验证码:")]),_vm._v(" "),_c('div',{staticClass:"captchas-img"},[_c('img',{attrs:{"src":_vm.captchaImg,"alt":"验证码"}}),_vm._v(" "),_c('a',{staticStyle:{"color":"#D6CDCB"},on:{"click":_vm.refreshCaptcha}},[_vm._v("换一张")])]),_vm._v(" "),_c('el-input',{attrs:{"type":"text","placeholder":"输入图片上的字母"},on:{"blur":_vm.blurCaptchaCode,"focus":function($event){_vm.focusInput('captchaCodeVerify')}},model:{value:(_vm.captchaCode),callback:function ($$v) {_vm.captchaCode=$$v},expression:"captchaCode"}}),_vm._v(" "),_c('div',{staticClass:"validate",class:_vm.captchaCodeVerify},[_c('i')])],1),_vm._v(" "),_c('div',{staticClass:"form-list mobile-validate"},[_c('label',[_vm._v("手机验证码:")]),_vm._v(" "),_c('el-input',{attrs:{"type":"text","placeholder":"输入手机获取的验证码"},on:{"blur":_vm.blurMobileCode,"focus":function($event){_vm.focusInput('mobileVerify')}},model:{value:(_vm.mobileCode),callback:function ($$v) {_vm.mobileCode=$$v},expression:"mobileCode"}}),_vm._v(" "),(!_vm.isCaptchaSame)?_c('a',{attrs:{"disabled":""}},[_c('b'),_vm._v("获取验证码")]):[_c('a',{class:{'hide': _vm.resendFlag},staticStyle:{"color":"#D6CDCB"},on:{"click":_vm.getMobileCode}},[_c('b'),_vm._v("获取验证码")]),_vm._v(" "),_c('span',{staticClass:"afterTime",class:{'hide': !_vm.resendFlag}},[_vm._v("倒计时"+_vm._s(_vm.time)+"秒")])],_vm._v(" "),_c('div',{staticClass:"validate",class:_vm.mobileVerify},[_c('i')])],2),_vm._v(" "),_c('div',{staticClass:"form-list",staticStyle:{"margin-top":"10px","height":"20px","line-height":"20px"}},[(_vm.warnMsg)?_c('div',{staticClass:"warning-content",class:_vm.warnVerify},[_c('i'),_vm._v(_vm._s(_vm.warnMsg)+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-list",staticStyle:{"margin-top":"0"}},[_c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"form-btn",on:{"click":_vm.handleBind}},[_vm._v("确认绑定")])],1)]):_c('div',{staticClass:"success"},[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("当前绑定手机号为： "+_vm._s(_vm.communicationInfo.phone))]),_vm._v(" "),_c('p',[_vm._v("您可以使用该手机号享有手机登录、手机找回等服务")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-notice"},[_c('img',{attrs:{"src":__webpack_require__("aAsa")}}),_vm._v("\n                已绑定\n            ")])}]


/***/ }),

/***/ "MX3j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            flag: true, // 防止重复提交
            loading: false,
            phoneNumber: null,
            phoneRegisted: false, // 手机号是否注册过
            phoneVerify: null,
            captchaCode: null,
            captchaCodeVerify: null,
            isCaptchaSame: false, // 图片验证码是否一致，一致时才能发送手机验证码
            captchaId: '', // 图片验证码ID
            captchaImg: '', // 图片验证码地址
            mobileCode: null,
            mobileVerify: null,
            time: 60, // 验证码发送60秒后可重发
            readMe: false,
            warnVerify: null,
            warnMsg: '',
            isSuccess: false // 是否绑定成功
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
        communicationInfo: function communicationInfo(state) {
            return state.user.communicationInfo;
        }
    }), {
        resendFlag: function resendFlag() {
            // 验证码重新发送标识
            return this.time !== 60;
        }
    }),
    created: function created() {
        var _this = this;

        if (!this.communicationInfo.checkBind) {
            this.USER_GET_COMMUNICATION().then(function (info) {
                if (info.phone) {
                    _this.isSuccess = true;
                }
            });
        } else if (this.communicationInfo.phone) {
            this.isSuccess = true;
        }
    },
    beforeMount: function beforeMount() {
        this.refreshCaptcha();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['USER_GET_CAPTCHA', 'USER_VERIFY_CAPTCHA', 'USER_GET_COMMUNICATION']), {
        // 输入框获取焦点移除相关错误提醒
        focusInput: function focusInput(item) {
            this[item] = '';
            if (item === 'phoneVerify') {
                this.phoneRegisted = false;
            }
            if (item === 'captchaCodeVerify') {
                this.isCaptchaSame = false;
            }
            this.warnVerify = '';
            this.warnMsg = '';
        },
        blurPhoneNumber: function blurPhoneNumber() {
            if (this.phoneNumber) {
                this.checkPhoneNumber();
            }
        },
        blurCaptchaCode: function blurCaptchaCode() {
            var captchaCode = this.captchaCode;
            var captchaId = this.captchaId;
            var captchaReg = /^\d{4}$/;
            var isCaptcha = captchaReg.test(captchaCode);
            if (isCaptcha && this.flag) {
                var that = this;
                that.captchaCodeVerify = 'checking';
                that.flag = false;
                that.USER_VERIFY_CAPTCHA({ captchaId: captchaId, inputText: captchaCode }).then(function () {
                    that.isCaptchaSame = true;
                    that.captchaCodeVerify = 'right';
                    that.flag = true;
                }).catch(function () {
                    that.flag = true;
                    that.captchaCodeVerify = 'error';
                    that.refreshCaptcha();
                });
            } else {
                if (captchaCode && !isCaptcha) {
                    this.captchaCodeVerify = 'error';
                }
            }
        },
        blurMobileCode: function blurMobileCode() {
            if (this.mobileCode) {
                this.checkMobileCode();
            }
        },
        checkPhoneNumber: function checkPhoneNumber() {
            var phoneNumber = this.phoneNumber;
            var phoneReg = /^1[3456789][0-9]{9}$/;
            if (phoneReg.test(phoneNumber) && !this.phoneRegisted) {
                this.phoneVerify = 'right';
                return true;
            }
            if (!phoneNumber) {
                this.phoneVerify = 'empty';
                return false;
            } else if (this.phoneRegisted) {
                this.phoneVerify = 'registed';
                return false;
            }
            this.phoneVerify = 'error';
            return false;
        },
        checkCaptchaCode: function checkCaptchaCode() {
            var captchaCode = this.captchaCode;
            var captchaId = this.captchaId;
            var captchaReg = /^\d{4}$/;
            if (captchaReg.test(captchaCode) && captchaId && this.isCaptchaSame) {
                this.captchaCodeVerify = 'right';
                return true;
            }
            if (!captchaCode) {
                this.captchaCodeVerify = 'empty';
                return false;
            }
            this.captchaCodeVerify = 'error';
            return false;
        },
        checkMobileCode: function checkMobileCode() {
            var mobileCode = this.mobileCode;
            var testReg = /^\d{4}$/;
            if (!mobileCode) {
                this.mobileVerify = 'empty';
                return false;
            } else if (testReg.test(mobileCode)) {
                this.mobileVerify = 'right';
                return true;
            }
            this.mobileVerify = 'error';
            return false;
        },

        // 刷新图片验证码
        refreshCaptcha: function refreshCaptcha() {
            if (this.flag) {
                var that = this;
                this.flag = false;
                that.USER_GET_CAPTCHA({ captchaId: this.captchaId }).then(function (data) {
                    that.captchaId = data.captchaId;
                    that.captchaImg = data.url;
                }).catch(function () {
                    that.captchaId = '';
                    that.captchaImg = '';
                }).finally(function () {
                    that.isCaptchaSame = false;
                    that.flag = true;
                });
            }
        },

        // 手机验证码等待60秒可重发
        waitFor60s: function waitFor60s() {
            var that = this;
            this.timer = setInterval(function () {
                if (that.time > 0) {
                    that.time -= 1;
                } else {
                    clearInterval(that.timer);
                    that.time = 60;
                }
            }, 1000);
        },
        getMobileCode: function getMobileCode() {
            if (this.flag) {
                var that = this;
                that.flag = false;
                that.mobileVerify = 'checking';
                setTimeout(function () {
                    var checkPhone = that.checkPhoneNumber();
                    var checkCaptcha = that.checkCaptchaCode();
                    if (checkPhone && checkCaptcha) {
                        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post('/v1/user-center/bind-phone-vcodes', {
                            phone: that.phoneNumber
                        }).then(function (resp) {
                            return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].checkResp(resp);
                        }).then(function () {
                            that.mobileVerify = 'right';
                            that.waitFor60s();
                        }).catch(function (err) {
                            if (err.code === 1008) {
                                that.phoneVerify = 'registed';
                            }
                            that.warnVerify = 'error';
                            that.warnMsg = err.msg;
                        }).finally(function () {
                            that.flag = true;
                        });
                    } else {
                        that.flag = true;
                        that.mobileVerify = '';
                    }
                }, 500);
            }
        },
        handleBind: function handleBind() {
            var _this2 = this;

            // 确认绑定
            if (this.flag) {
                var that = this;
                that.flag = false;
                that.warnVerify = 'checking';
                setTimeout(function () {
                    // 手机验证
                    var checkPhone = that.checkPhoneNumber();
                    var checkMobileCode = that.checkMobileCode();
                    if (checkPhone && checkMobileCode) {
                        _this2.loading = true;
                        var phone = that.phoneNumber;
                        var vCode = that.mobileCode;

                        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post('/v1/user-center/bind-phone', {
                            phone: phone,
                            vCode: vCode
                        }).then(function (resp) {
                            return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].checkResp(resp);
                        }).then(function () {
                            that.warnVerify = '';
                            that.USER_GET_COMMUNICATION();
                            // 绑定成功
                            that.isSuccess = true;
                        }).catch(function (err) {
                            that.warnVerify = 'error';
                            that.warnMsg = err.msg;
                        }).finally(function () {
                            that.flag = true;
                            that.loading = false;
                        });
                    } else {
                        that.warnVerify = '';
                        that.flag = true;
                    }
                }, 500);
            }
        }
    })
});

/***/ }),

/***/ "UVZW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBind_vue__ = __webpack_require__("MX3j");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a1f1ae3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBind_vue__ = __webpack_require__("Fgb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("k04W")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a1f1ae3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBind_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a1f1ae3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBind_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a1f1ae3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBind_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aAsa":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAb1BMVEUAAABQwlpQwVlizmJQwVpQwVlRwVlTw1tSxF1QwFlQwVlQwFlUyGBQwlpRwV1Uxl1RwFpRwVlRwVpSwlpQwVpm0mtQwVpRwlpRwVlQwVpQwFpRwVlRwVtRwlpVxVtZyGRixGJTwFxQwlpRwVpQwFnEsxXMAAAAJHRSTlMAasAK7pD7MSLfyOgSWikcnec5YdIFvE728diuh4UnFw0+gK2aFu9aAAACkUlEQVRo3s3a2Y6bMBiG4T8dMNgxZc0ygaz97v8aK2UqWQ1OwPaPxXs4c/Aodha80Nx00w696mQiRCI71Q9to4mzsqgkLMmqKHmEy/mED53Ol1BBbxQmUxsdMkzpEbM6pr7DllcCsxNV7kHcUgGnRHpzNYoaztWF20jt4dXeYcwOCTxLDjOJXYqA0t0c46oQlLpOG7lEYHJyYrIawdXZZ+P+DYa+7x9fhzHClOzDfNRgqn47L1cJtuTVbuwUGFM7K5KCtdRmHMDcwTLpCTeSjCd/D/b2r0aBBSr+N241Fqi+Tbyz+N9hucAiiZxMFRaqMkYpsFCi5J2R7lE8uvezoo8MxmNnfTw46n/IhsHYmM+0/R+Kz6A7XlL07MJokMZrPyuLM6NBOV47P/9+YjSoHa+Snh8STkPXGFUSUcFofP16811c8Rr2rxa5sAFJpJc2AE3N4gYaahc30NIAW2mjm1TwGBioxzjx88jUJCwGelIffpqzhMOAog7jMjJKuIHO+jH5IqOEG5CU2F+JUYINJCQw7kEjJcCAsCIiGyk+hkGsw7H9PVL8DSQk4aB4GZDUwUHxMtCRgoPiZUBRDwfFy0BPAxwULwMDtXBQvAy01GC24mmgIY3ZSutnQBPJ2YqnIc0j0YTiZZhHogIOijHcFtolppQwA6V54J5Q/I2TWTpMKJ6GWTpcMK34G7jQM+WgOBvKLEynFU8DG4cl9rZ5LpicjaN22SwQf9oiTeBaGmXbI8YGTpStqBibalG2B2NsdMbYso22+Rx/G53/QCDK0Ub8QxpTvuUytnm8g7P4R4CmbMswVtkajmU5DpjXclQeeOi/rusL3hcx1nilxONyzHqv+bhcWFr/1SueS2RRrsP9BYZo3cWjKVzfAAAAAElFTkSuQmCC"

/***/ }),

/***/ "jxbR":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".user-bind[data-v-4a1f1ae3]{padding:70px 55px}.bind-phone[data-v-4a1f1ae3]{height:40px;margin-bottom:16px}.bind-phone span[data-v-4a1f1ae3]{width:83px;height:40px;line-height:40px;margin-right:10px;display:inline-block;font-size:14px;color:#333;letter-spacing:9px}.bind-phone input[data-v-4a1f1ae3]{width:380px;height:40px;line-height:40px;display:inline-block;padding-left:10px;border:1px solid #e7e7e7;font-size:14px}.bind-phone input[data-v-4a1f1ae3]::-webkit-input-placeholder{color:#b1b1b1}.bind-phone img[data-v-4a1f1ae3]{margin-left:10px;width:16px;height:16px}.captchas-validate[data-v-4a1f1ae3]{height:40px;margin-bottom:16px}.captchas-validate span[data-v-4a1f1ae3]{width:86px;height:40px;line-height:40px;margin-right:10px;display:inline-block;font-size:14px;color:#333;float:left}.captchas-validate input[data-v-4a1f1ae3]{width:270px;height:40px;line-height:40px;display:inline-block;padding-left:10px;border:1px solid #e7e7e7;float:left;font-size:14px}.captchas-validate input[data-v-4a1f1ae3]::-webkit-input-placeholder{color:#b1b1b1}.captchas-validate .captchas-img[data-v-4a1f1ae3]{width:100px;height:40px;border:1px solid #e7e7e7;display:inline-block;margin-left:10px;position:relative;text-align:center;line-height:40px;overflow:hidden}.captchas-validate .captchas-img img[data-v-4a1f1ae3]{width:100%;height:40px}.captchas-validate .captchas-img img:hover~a[data-v-4a1f1ae3]{-webkit-transition:opacity,top 1s ease-in-out 0s;transition:opacity,top 1s ease-in-out 0s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;opacity:1;top:0;color:#fff}.captchas-validate .captchas-img a[data-v-4a1f1ae3]{width:100%;height:40px;display:block;position:absolute;top:40px;opacity:0;background:rgba(0,0,0,.5)}.captchas-validate .captchas-img a[data-v-4a1f1ae3]:hover{color:#fff;opacity:1;top:0;z-index:99;cursor:pointer}.mobile-validate[data-v-4a1f1ae3]{height:40px;margin-bottom:16px}.mobile-validate span[data-v-4a1f1ae3]{width:86px;height:40px;line-height:40px;margin-right:10px;display:inline-block;font-size:14px;color:#333;float:left}.mobile-validate input[data-v-4a1f1ae3]{width:270px;height:40px;line-height:40px;display:inline-block;padding-left:10px;border:1px solid #e7e7e7;float:left;font-size:14px}.mobile-validate input[data-v-4a1f1ae3]::-webkit-input-placeholder{color:#b1b1b1}.mobile-validate .afterTime[data-v-4a1f1ae3],.mobile-validate a[data-v-4a1f1ae3]{width:100px;height:40px;border:1px solid #e7e7e7;display:inline-block;margin-left:10px;text-align:center;line-height:40px;color:#b1b1b1;z-index:999;cursor:pointer}.mobile-validate .hide[data-v-4a1f1ae3]{display:none}.go-bind[data-v-4a1f1ae3]{width:382px;height:40px;padding:0;line-height:40px;margin-left:94px;font-size:16px;border-radius:2px}.success[data-v-4a1f1ae3]{width:100%;min-height:555px;background-color:#fff;padding-top:188px}.success .success-notice[data-v-4a1f1ae3]{height:50px;width:300px;margin:0 auto;margin-bottom:20px;line-height:50px;text-align:center;font-size:18px;color:#50c059}.success .success-notice img[data-v-4a1f1ae3]{width:50px;height:50px;vertical-align:middle;margin-right:20px}.success p[data-v-4a1f1ae3]{width:330px;margin:0 auto;text-align:center;height:20px;line-height:20px;margin-bottom:5px;font-size:14px;color:#4d4d4d}.mobile-validate a[data-v-4a1f1ae3]{background-color:#fff!important;color:#d6cdcb}", "", {"version":3,"sources":["/home/work/jenkins/workspace/FD-FE_hfsfd-student/src/views/index/components/UserBind.vue"],"names":[],"mappings":"AAGA,4BACE,iBAAmB,CACpB,AACD,6BACE,YAAa,AACb,kBAAoB,CACrB,AACD,kCACI,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,qBAAsB,AACtB,eAAgB,AAChB,WAAY,AACZ,kBAAoB,CACvB,AACD,mCACI,YAAa,AACb,YAAa,AACb,iBAAkB,AAClB,qBAAsB,AACtB,kBAAmB,AACnB,yBAA0B,AAC1B,cAAgB,CACnB,AACD,8DACI,aAAe,CAClB,AACD,iCACI,iBAAkB,AAClB,WAAY,AACZ,WAAa,CAChB,AACD,oCACE,YAAa,AACb,kBAAoB,CACrB,AACD,yCACI,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,qBAAsB,AACtB,eAAgB,AAChB,WAAY,AACZ,UAAY,CACf,AACD,0CACI,YAAa,AACb,YAAa,AACb,iBAAkB,AAClB,qBAAsB,AACtB,kBAAmB,AACnB,yBAA0B,AAC1B,WAAY,AACZ,cAAgB,CACnB,AACD,qEACI,aAAe,CAClB,AACD,kDACI,YAAa,AACb,YAAa,AACb,yBAA0B,AAC1B,qBAAsB,AACtB,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,iBAAkB,AAClB,eAAiB,CACpB,AACD,sDACM,WAAY,AACZ,WAAa,CAClB,AACD,8DACM,iDAAmD,AACnD,yCAA2C,AAC3C,qCAAsC,AAC9B,6BAA8B,AACtC,UAAW,AACX,MAAO,AACP,UAAY,CACjB,AACD,oDACM,WAAY,AACZ,YAAa,AACb,cAAe,AACf,kBAAmB,AACnB,SAAU,AACV,UAAW,AACX,yBAA+B,CACpC,AACD,0DACM,WAAY,AACZ,UAAW,AACX,MAAO,AACP,WAAY,AACZ,cAAgB,CACrB,AACD,kCACE,YAAa,AACb,kBAAoB,CACrB,AACD,uCACI,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,qBAAsB,AACtB,eAAgB,AAChB,WAAY,AACZ,UAAY,CACf,AACD,wCACI,YAAa,AACb,YAAa,AACb,iBAAkB,AAClB,qBAAsB,AACtB,kBAAmB,AACnB,yBAA0B,AAC1B,WAAY,AACZ,cAAgB,CACnB,AACD,mEACI,aAAe,CAClB,AACD,iFAEI,YAAa,AACb,YAAa,AACb,yBAA0B,AAC1B,qBAAsB,AACtB,iBAAkB,AAClB,kBAAmB,AACnB,iBAAkB,AAClB,cAAe,AACf,YAAa,AACb,cAAgB,CACnB,AACD,wCACI,YAAc,CACjB,AACD,0BACE,YAAa,AACb,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,iBAAkB,AAClB,eAAgB,AAChB,iBAAmB,CACpB,AACD,0BACE,WAAY,AACZ,iBAAkB,AAClB,sBAAuB,AACvB,iBAAmB,CACpB,AACD,0CACI,YAAa,AACb,YAAa,AACb,cAAe,AACf,mBAAoB,AACpB,iBAAkB,AAClB,kBAAmB,AACnB,eAAgB,AAChB,aAAe,CAClB,AACD,8CACM,WAAY,AACZ,YAAa,AACb,sBAAuB,AACvB,iBAAmB,CACxB,AACD,4BACI,YAAa,AACb,cAAe,AACf,kBAAmB,AACnB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,eAAgB,AAChB,aAAe,CAClB,AACD,oCACE,gCAAkC,AAClC,aAAe,CAChB","file":"UserBind.vue","sourcesContent":["\n@charset \"UTF-8\";\n/*颜色库*/\n.user-bind[data-v-4a1f1ae3] {\n  padding: 70px 55px;\n}\n.bind-phone[data-v-4a1f1ae3] {\n  height: 40px;\n  margin-bottom: 16px;\n}\n.bind-phone span[data-v-4a1f1ae3] {\n    width: 83px;\n    height: 40px;\n    line-height: 40px;\n    margin-right: 10px;\n    display: inline-block;\n    font-size: 14px;\n    color: #333;\n    letter-spacing: 9px;\n}\n.bind-phone input[data-v-4a1f1ae3] {\n    width: 380px;\n    height: 40px;\n    line-height: 40px;\n    display: inline-block;\n    padding-left: 10px;\n    border: 1px solid #e7e7e7;\n    font-size: 14px;\n}\n.bind-phone input[data-v-4a1f1ae3]::-webkit-input-placeholder {\n    color: #b1b1b1;\n}\n.bind-phone img[data-v-4a1f1ae3] {\n    margin-left: 10px;\n    width: 16px;\n    height: 16px;\n}\n.captchas-validate[data-v-4a1f1ae3] {\n  height: 40px;\n  margin-bottom: 16px;\n}\n.captchas-validate span[data-v-4a1f1ae3] {\n    width: 86px;\n    height: 40px;\n    line-height: 40px;\n    margin-right: 10px;\n    display: inline-block;\n    font-size: 14px;\n    color: #333;\n    float: left;\n}\n.captchas-validate input[data-v-4a1f1ae3] {\n    width: 270px;\n    height: 40px;\n    line-height: 40px;\n    display: inline-block;\n    padding-left: 10px;\n    border: 1px solid #e7e7e7;\n    float: left;\n    font-size: 14px;\n}\n.captchas-validate input[data-v-4a1f1ae3]::-webkit-input-placeholder {\n    color: #b1b1b1;\n}\n.captchas-validate .captchas-img[data-v-4a1f1ae3] {\n    width: 100px;\n    height: 40px;\n    border: 1px solid #e7e7e7;\n    display: inline-block;\n    margin-left: 10px;\n    position: relative;\n    text-align: center;\n    line-height: 40px;\n    overflow: hidden;\n}\n.captchas-validate .captchas-img img[data-v-4a1f1ae3] {\n      width: 100%;\n      height: 40px;\n}\n.captchas-validate .captchas-img img:hover ~ a[data-v-4a1f1ae3] {\n      -webkit-transition: opacity, top 1s ease-in-out 0s;\n      transition: opacity, top 1s ease-in-out 0s;\n      -webkit-animation-fill-mode: forwards;\n              animation-fill-mode: forwards;\n      opacity: 1;\n      top: 0;\n      color: #fff;\n}\n.captchas-validate .captchas-img a[data-v-4a1f1ae3] {\n      width: 100%;\n      height: 40px;\n      display: block;\n      position: absolute;\n      top: 40px;\n      opacity: 0;\n      background: rgba(0, 0, 0, 0.5);\n}\n.captchas-validate .captchas-img a[data-v-4a1f1ae3]:hover {\n      color: #fff;\n      opacity: 1;\n      top: 0;\n      z-index: 99;\n      cursor: pointer;\n}\n.mobile-validate[data-v-4a1f1ae3] {\n  height: 40px;\n  margin-bottom: 16px;\n}\n.mobile-validate span[data-v-4a1f1ae3] {\n    width: 86px;\n    height: 40px;\n    line-height: 40px;\n    margin-right: 10px;\n    display: inline-block;\n    font-size: 14px;\n    color: #333;\n    float: left;\n}\n.mobile-validate input[data-v-4a1f1ae3] {\n    width: 270px;\n    height: 40px;\n    line-height: 40px;\n    display: inline-block;\n    padding-left: 10px;\n    border: 1px solid #e7e7e7;\n    float: left;\n    font-size: 14px;\n}\n.mobile-validate input[data-v-4a1f1ae3]::-webkit-input-placeholder {\n    color: #b1b1b1;\n}\n.mobile-validate a[data-v-4a1f1ae3],\n  .mobile-validate .afterTime[data-v-4a1f1ae3] {\n    width: 100px;\n    height: 40px;\n    border: 1px solid #e7e7e7;\n    display: inline-block;\n    margin-left: 10px;\n    text-align: center;\n    line-height: 40px;\n    color: #b1b1b1;\n    z-index: 999;\n    cursor: pointer;\n}\n.mobile-validate .hide[data-v-4a1f1ae3] {\n    display: none;\n}\n.go-bind[data-v-4a1f1ae3] {\n  width: 382px;\n  height: 40px;\n  padding: 0;\n  line-height: 40px;\n  margin-left: 94px;\n  font-size: 16px;\n  border-radius: 2px;\n}\n.success[data-v-4a1f1ae3] {\n  width: 100%;\n  min-height: 555px;\n  background-color: #fff;\n  padding-top: 188px;\n}\n.success .success-notice[data-v-4a1f1ae3] {\n    height: 50px;\n    width: 300px;\n    margin: 0 auto;\n    margin-bottom: 20px;\n    line-height: 50px;\n    text-align: center;\n    font-size: 18px;\n    color: #50c059;\n}\n.success .success-notice img[data-v-4a1f1ae3] {\n      width: 50px;\n      height: 50px;\n      vertical-align: middle;\n      margin-right: 20px;\n}\n.success p[data-v-4a1f1ae3] {\n    width: 330px;\n    margin: 0 auto;\n    text-align: center;\n    height: 20px;\n    line-height: 20px;\n    margin-bottom: 5px;\n    font-size: 14px;\n    color: #4d4d4d;\n}\n.mobile-validate a[data-v-4a1f1ae3] {\n  background-color: #fff !important;\n  color: #d6cdcb;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "k04W":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("jxbR");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("rjj0").default
var update = add("7b549acc", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/46.8dd6cd5a6635f91475ff.js